interface IToolbarProps {
  className?: string
  children: React.ReactNode
}

/**
 * Toolbar that was intended to be directly below `lht-qra-page-header`
 * @param children toolbar content
 * @param className tailwind classes for outer div
 * @returns toolbar
 */
const Toolbar = ({ children, className = '' }: IToolbarProps) => {
  return (
    <div
      className={[
        'flex items-center pl-4 pr-6 border-y border-gray-300',
        className
      ].join(' ')}
    >
      {children}
    </div>
  )
}

interface ISeparatorProps {
  className?: string
}

/**
 * Vertical pipe separator visual
 * @param className optional tailwind classes for outer div
 * @returns separator element
 */
export const Separator = ({ className = '' }: ISeparatorProps) => {
  return <div role='separator' className={`h-full border-l ${className}`} />
}

export default Toolbar
